import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// ── iOS: "aşağı çekince yenile" davranışını kapat ─────────────────────────
// Yalnızca iPhone/iPad'de köke `ios-no-bounce` sınıfı eklenir (CSS karşılığı
// index.css'te). Chrome/Android'e hiç dokunmaz.
try {
  const ua = navigator.userAgent || "";
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (navigator.platform === "MacIntel" && (navigator.maxTouchPoints || 0) > 1);
  if (isIOS) document.documentElement.classList.add("ios-no-bounce");
} catch { /* sessiz */ }

// ── iOS uygulaması: durum çubuğu payı ──────────────────────────────────────
// Paketlenmiş iOS uygulamasında WKWebView tüm ekranı kaplar ama
// `env(safe-area-inset-top)` 0 döner. Sonuç: başlık çubuğu saatin ve pil
// simgesinin ALTINDA kalır — kullanıcının gördüğü çakışma tam olarak budur.
// Bu sınıf, index.css'teki `--sk-safe-top` değişkenini 56px tabanına çeker.
// SADECE paketlenmiş iOS'ta: Safari'de veya Android'de eklenmez, çünkü orada
// env() doğru çalışıyor ve 56px eklemek başlığı boşluğa iterdi.
try {
  const cap = typeof window !== "undefined" ? window.Capacitor : null;
  if (cap?.isNativePlatform?.() && cap.getPlatform?.() === "ios") {
    document.documentElement.classList.add("sk-ios-native");
  }
} catch { /* sessiz */ }

// ── Deploy sonrası "Loading chunk failed" koruması ─────────────────────────
// Ana çözüm ErrorBoundary'de (render sırasında patlayan lazy-route chunk'ları).
// Bazı dinamik-import hataları ise yakalanmamış promise reddi olarak yüzeye
// çıkar ve error boundary'ye düşmez; onları burada yakalayıp sayfayı BİR KEZ
// tazeliyoruz. index.html no-cache olduğu için reload taze main.js + doğru
// chunk'ları getirir. Sonsuz döngüyü sessionStorage ile engelliyoruz.
function _isChunkError(msg) {
  return (
    /loading chunk [\w-]+ failed/i.test(msg) ||
    /chunkloaderror/i.test(msg) ||
    /loading css chunk/i.test(msg) ||
    /error loading dynamically imported module/i.test(msg) ||
    /failed to fetch dynamically imported module/i.test(msg)
  );
}
function _maybeReloadOnChunkError(msg) {
  if (!_isChunkError(String(msg || ""))) return;
  try {
    const n = Number(sessionStorage.getItem("__cr_n__") || 0);
    const last = Number(sessionStorage.getItem("__cr_t__") || 0);
    if (n < 2 && Date.now() - last > 10000) {
      sessionStorage.setItem("__cr_n__", String(n + 1));
      sessionStorage.setItem("__cr_t__", String(Date.now()));
      window.location.reload();
    }
  } catch { /* sessionStorage kapalıysa sessizce devam */ }
}
window.addEventListener("unhandledrejection", (e) => {
  _maybeReloadOnChunkError(e?.reason?.message || e?.reason);
});
// Sayfa birkaç saniye sorunsuz çalıştıysa reload sayacını sıfırla ki ileriki
// deploy'larda tazeleme bütçesi yeniden dolsun.
window.addEventListener("load", () => {
  setTimeout(() => {
    try { sessionStorage.removeItem("__cr_n__"); } catch { /* noop */ }
  }, 6000);
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
